<template>
    <div class="frq-page">
      <div class="content">
        <div class="wrapper">
          <div class="content-header" style="justify-content: initial;">
            <div class="header-icon">
              <i class="fas fa-file-alt"></i>
            </div>
            <span>Free Response Questions</span>
          </div>
          <div class="question-content" v-html="question.question"></div>
        </div>
      </div>
      <div class="operation" style="width:600px">
        <div class="wrapper">
          <div class="operation-header">
            <div class="header-icon">
              <i class="fas fa-code"></i>
            </div>
            <span>Code Editor</span>
            <div class="header-actions">
              <button class="action-btn" @click="saveCode">
                <i class="fas fa-download"></i> Save
              </button>
              <button class="action-btn primary" @click="openDrawer">
                <i class="fas fa-lightbulb"></i> Analysis
              </button>
            </div>
          </div>
          <editor v-model="code" lang="java" theme="chrome" class="editor editor-font-2" ref="aceEditor" id="codeEditor" 
            :options="editorOptions"
          ></editor>
        </div>
      </div>

      <div id="frq-drawer" class="drawer" :class="{ open: showDrawer }">
        <div class="drawer-content">
          <div class="drawer-header">
            <div class="header-icon">
              <i class="fas fa-lightbulb"></i>
            </div>
            <span>Question Analysis</span>
            <button class="close-btn" @click="closeDrawer">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="analysis-content" v-html="question.analysis"></div>
        </div>
      </div>
      <div id="overlay" class="overlay" :class="{ open: showDrawer }" @click="closeDrawer"></div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import editor from 'vue2-ace-editor'
  import bus from '../utils/bus';
  import util from '../utils/util';
  require('brace/mode/java');
  require('brace/theme/chrome');
  
  export default {
    data() {
      return {
        question: {},
        questionId: 0,
        optionId: -1,
        map: new Map(),
        exam: {},
        favorite: [],
        userInfo:{},
        code:"",
        showDrawer: false,
        editorOptions: {
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          enableLinking: false,
          foldStyle: 'manual',
        }
      };
    },
    components:{
      editor
    },
    computed:{
      isFav(){
        var questionId = this.question.id;
        if(!questionId){
          return false;
        }
        var filterR = this.favorite.filter( r=> r == questionId);
        return filterR.length >0;
      }
    },
    mounted(){
      var user = localStorage.getItem('user');
      if(user && user != null && user != ''){
        var userObj = JSON.parse(user);
        this.userInfo = userObj;
      }
      else{
        location.href = '/';
        return;
      }
  
      var year = util.getSearchString("year");
      var q = util.getSearchString("q");
      this.$http.get('https://ap.dctechonline.cn/data/problems/'+year+'/'+q+'.json?t='+new Date().getTime()).then(res=>{
        var qId = res.data[0];
        this.$http.get("https://apapi.dctechonline.cn/api/frq/"+qId).then(res1=>{
          console.log(res1);
          this.question = res1.data;
        })
      });
    },
    methods: {
      async loadFav(){
        try {
          const userId = this.userInfo.UserId;
          const response = await axios.get(`https://apapi.dctechonline.cn/api/favorite/${userId}/0`);
          this.favorite = [];
          response.data.forEach( r=>{
            this.favorite.push(r.id);
          })
        } catch (err) {
        }
      },
      saveCode(){
        if(this.code.trim() == ''){
          alert('No code to save')
          return;
        }
        const blob = new Blob([this.code], { type: 'text/plain' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'code.java';
        a.click();
        window.URL.revokeObjectURL(url);
      },
      closeDrawer(){
        this.showDrawer = false;
      },
      openDrawer(){
        this.showDrawer = true;
      },
      setAnswer(id, a) {
        this.map.set(id, a);
        this.optionId = a;
        this.question = { ...this.question };
      },
      isFav(question){
        var questionId = question.Id;
        if(questionId){
          var filterR = this.favorite.filter( r=> r.Id = questionId);
          return filterR.length >0;
        }
        else{
          return false;
        }
      },
      getStatus(index) {
        if (this.map.has(this.exam.questions[index].id)) {
          const ans = this.exam.questions[index].answer[0];
          if (ans == this.map.get(this.exam.questions[index].id)) {
            return 1;
          } else {
            return 0;
          }
        } else {
          return -1;
        }
      },
      addTofav(question){
        const id = question.id;
        const userId = this.userInfo.UserId;
  
        this.$http.post('https://apapi.dctechonline.cn/api/favorite', {
          questionId: id,
          userId: userId
        }).then(response => {
          this.loadFav();
        });
      },
      cancelFav(question){
        const id = question.id;
        const userId = this.userInfo.UserId;
        this.$http.delete(`https://apapi.dctechonline.cn/api/favorite/${userId}/${id}`).then(response => {
          this.loadFav();
        });
      },
      loadQuestion(q, index) {
        axios.get(`https://apapi.dctechonline.cn/api/question-real/${q}`).then((response) => {
          this.question = response.data;
          this.questionId = index;
          if (this.map.has(this.exam.questions[this.questionId].id)) {
            this.optionId = this.map.get(this.exam.questions[this.questionId].id);
          } else {
            this.optionId = -1;
          }
        });
      },
      getAlpha(index) {
        switch (index) {
          case 0:
            return 'A';
          case 1:
            return 'B';
          case 2:
            return 'C';
          case 3:
            return 'D';
          case 4:
            return 'E';
          default:
            return '';
        }
      },
    }
  };
  </script>
  
  <style lang="scss">
  @import '@/styles/variables.scss';
  
  .frq-page {
    position: fixed;
    left: 0;
    top: 56px;
    width: 100%;
    height: calc(100% - 56px);
    display: flex;
    background: $bg-primary;
  }
  
  .content {
    height: 100%;
    flex: 1;
    padding: 12px;
    min-width: 400px;
  }
  
  .content .wrapper {
    background: white;
    height: 100%;
    padding: 20px;
    border-radius: 12px;
    box-shadow: $shadow-card;
    border: 1px solid $border-light;
    overflow: auto;
    display: flex;
    flex-direction: column;
    
    @include scrollbar-custom;
  }
  
  .content-header, .operation-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid $border-light;
    font-weight: 600;
    font-size: 15px;
    color: $primary-color;
    
    .header-icon {
      width: 28px;
      height: 28px;
      background: rgba($primary-color, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
    }
  }
  
  .operation-header {
    .header-actions {
      margin-left: auto;
      display: flex;
      gap: 8px;
    }
    
    .action-btn {
      background: rgba($primary-color, 0.1);
      color: $primary-color;
      border: none;
      padding: 6px 12px;
      border-radius: 8px;
      font-size: 12px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      gap: 6px;
      
      &:hover {
        background: rgba($primary-color, 0.2);
      }
      
      &.primary {
        background: $primary-gradient;
        color: white;
        
        &:hover {
          box-shadow: 0 4px 12px rgba($primary-color, 0.3);
        }
      }
    }
  }
  
  .question-content {
    flex: 1;
    font-size: 14px;
    line-height: 1.8;
    color: $text-primary;
    
    p {
      margin-bottom: 16px;
    }
    
    code {
      background: $bg-secondary;
      padding: 2px 8px;
      border-radius: 4px;
      font-family: $font-mono;
      font-size: 13px;
      color: $primary-dark;
    }
    
    pre {
      background: $bg-dark;
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      overflow-x: auto;
      margin: 16px 0;
      
      code {
        background: transparent;
        padding: 0;
        color: inherit;
      }
    }
  }
  
  .operation {
    width: 600px;
    height: 100%;
    padding: 12px;
  }
  
  .operation .wrapper {
    background: white;
    height: 100%;
    padding: 20px;
    border-radius: 12px;
    box-shadow: $shadow-card;
    border: 1px solid $border-light;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  .editor {
    flex: 1;
    border-radius: 10px;
    border: 1px solid $border-light;
    overflow: hidden;
    
    &.editor-font-1 {
      font-size: 12px !important;
    }
  
    &.editor-font-2 {
      font-size: 14px !important;
    }
  
    &.editor-font-3 {
      font-size: 16px !important;
    }
  }
  
  .ace-chrome .ace_print-margin {
    display: none;
  }
  
  .drawer {
    position: fixed;
    top: 0;
    right: -700px;
    width: 700px;
    max-width: 100%;
    height: 100%;
    background-color: white;
    transition: right 0.3s ease-in-out;
    z-index: 1000;
    overflow: auto;
    box-shadow: -10px 0 40px rgba(0, 0, 0, 0.1);
  }
  
  .drawer.open {
    right: 0;
  }
  
  .drawer-content {
    padding: 24px;
  }
  
  .drawer-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid $border-light;
    font-weight: 600;
    font-size: 16px;
    color: $primary-color;
    
    .header-icon {
      width: 32px;
      height: 32px;
      background: rgba($accent-color, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $accent-color;
      font-size: 14px;
    }
    
    .close-btn {
      margin-left: auto;
      background: none;
      border: none;
      color: $text-muted;
      font-size: 18px;
      cursor: pointer;
      padding: 4px;
      transition: color 0.2s;
      
      &:hover {
        color: $text-primary;
      }
    }
  }
  
  .analysis-content {
    font-size: 14px;
    line-height: 1.8;
    color: $text-secondary;
    
    p {
      margin-bottom: 16px;
    }
    
    code {
      background: transparent;
      padding: 0;
      border-radius: 0;
      font-family: $font-mono;
      font-size: 13px;
      color: inherit;
    }
    
    pre {
      background: $bg-dark;
      color: white;
      padding: 16px 20px;
      border-radius: 12px;
      overflow-x: auto;
      margin: 16px 0;
    }
  }
  
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(4px);
    z-index: 999;
    display: none;
  }
  
  .overlay.open {
    display: block;
  }
  
  table {
    border-collapse: collapse;
    margin: 10px 0;
    
    td, th {
      border: 1px solid $border-color;
      padding: 8px 12px;
      text-align: left;
    }
    
    th {
      background: $bg-secondary;
      font-weight: 600;
    }
  }
  </style>
